import { HttpClient, HttpParams } from '@angular/common/http';
import { Organization } from '@app/types/organization.enum';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var OeLocationService = /** @class */ (function () {
    function OeLocationService(http) {
        this.http = http;
        this.api = environment.oeLocationService;
    }
    OeLocationService.prototype.getContactPhoneByCountryIsoCode = function (countryIsoCode, organization) {
        var params = new HttpParams().set('isocode', countryIsoCode);
        return this.http
            .get(this.api + "/countries", { params: params })
            .pipe(map(function (countries) {
            if (countries.length !== 1) {
                return null;
            }
            var country = countries[0];
            if (!country.phone) {
                return null;
            }
            if (organization === Organization.NextU) {
                return country.phone.nextuContactPhone;
            }
            return country.phone.oeContactPhone;
        }));
    };
    OeLocationService.ngInjectableDef = i0.defineInjectable({ factory: function OeLocationService_Factory() { return new OeLocationService(i0.inject(i1.HttpClient)); }, token: OeLocationService, providedIn: "root" });
    return OeLocationService;
}());
export { OeLocationService };
